import Spinners from "components/Shared/Spinners"
import { QRCodeCanvas } from "qrcode.react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap"
import { getJobApplicationDetails } from "store/actions/jobApplicationAction"

const CandidateDetails = ({ uuid }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState("general")
  const { loading, isLoading, jobApplicationDetails } = useSelector(
    state => state.JobApplication
  )

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  useEffect(() => {
    getDetails()
  }, [])

  const getDetails = () => {
    dispatch(getJobApplicationDetails(uuid))
  }

  const documentsObject =
    !loading && jobApplicationDetails?.documents
      ? jobApplicationDetails.documents.reduce((acc, doc) => {
          if (doc.file_type && doc.file_url) {
            acc[doc.file_type] = doc.file_url // Store the file_url for each file_type
          }
          return acc
        }, {})
      : {}

  return (
    <div className="assessment_candidate_details">
      {" "}
      {loading ? (
        <Spinners />
      ) : (
        <Container fluid>
          <Row>
            <Col lg="12">
              <Nav tabs className="one_line_parent">
                <NavItem>
                  <NavLink
                    className={activeTab === "general" ? "active" : ""}
                    onClick={() => toggleTab("general")}
                  >
                    {t("General Information")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "bank" ? "active" : ""}
                    onClick={() => toggleTab("bank")}
                  >
                    {t("Bank Information")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "job" ? "active" : ""}
                    onClick={() => toggleTab("job")}
                  >
                    {t("Job Information")}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "documents" ? "active" : ""}
                    onClick={() => toggleTab("documents")}
                  >
                    {t("Documents")}
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="py-3">
                {/* General Information Tab */}
                <TabPane tabId="general">
                  <Card className="theme_card">
                    <CardBody>
                      <Table className="table-wrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>
                              {jobApplicationDetails?.user_information?.id}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Profile Picture")}</th>
                            <td>
                              <div>
                                <img
                                  src={
                                    jobApplicationDetails?.user_information
                                      ?.profile_picture
                                  }
                                  alt=""
                                  style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                    maxHeight: 200,
                                  }}
                                  className="img-fluid"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("First Name(English)")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.first_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Middle Name(English)")}</th>
                            <td>
                              {jobApplicationDetails?.user_information
                                ?.middle_name || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Last Name(English)")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.last_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("First Name(Arabic)")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.first_name_ar
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Middle Name(Arabic)")}</th>
                            <td>
                              {jobApplicationDetails?.user_information
                                ?.middle_name_ar || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Last Name(Arabic)")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.last_name_ar
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Phone Number")}</th>
                            <td>
                              <p className="ltr fit_content">
                                {
                                  jobApplicationDetails?.user_information
                                    ?.phone_code
                                }{" "}
                                {
                                  jobApplicationDetails?.user_information
                                    ?.phone_number
                                }
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("National Id")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.national_id
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Registered Year")}</th>
                            <td>
                              {
                                jobApplicationDetails?.user_information
                                  ?.registered_year
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("National Id Expire Date")}</th>
                            <td>
                              <p className="ltr fit_content">
                                {jobApplicationDetails?.user_information
                                  ?.national_id_exp_date || "-"}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Last Logged In At")}</th>
                            <td>
                              <p className="ltr fit_content">
                                {
                                  jobApplicationDetails?.user_information
                                    ?.last_logged_in_at
                                }
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Nationality")}</th>
                            <td>
                              {" "}
                              {
                                jobApplicationDetails?.job_application
                                  ?.nationality_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Date of Birth")}</th>
                            <td>
                              {" "}
                              {jobApplicationDetails?.user_information?.dob}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Gender")}</th>
                            <td>
                              {" "}
                              {t(
                                jobApplicationDetails?.user_information?.gender
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("City of Residence")}</th>
                            <td>
                              {
                                jobApplicationDetails?.job_application
                                  ?.city_name
                              }
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </TabPane>

                {/* Bank Information Tab */}
                <TabPane tabId="bank">
                  <Card>
                    <CardBody>
                      <Table className="table-wrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Bank Name")}</th>
                            <td>
                              {" "}
                              {
                                jobApplicationDetails?.job_application
                                  ?.bank_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("IBAN Number")}</th>
                            <td>
                              {
                                jobApplicationDetails?.job_application
                                  ?.bank_iban
                              }
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </TabPane>

                {/* Job Information Tab */}
                <TabPane tabId="job">
                  <Card>
                    <CardBody>
                      <Table className="table-wrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">
                              {t("Educational Qualification")}
                            </th>
                            <td>
                              {
                                jobApplicationDetails?.job_application
                                  ?.education_qualification_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Specialization")}</th>
                            <td>
                              {
                                jobApplicationDetails?.job_application
                                  ?.specialization_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Language")}</th>
                            <td>
                              {jobApplicationDetails?.job_application?.languages?.map(
                                item => item.name + ", "
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Uniform Size")}</th>
                            <td>
                              {
                                jobApplicationDetails?.job_application
                                  ?.uniform_size_name
                              }
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              {t(
                                "Do you have chronic illnesses or health issues?"
                              )}
                            </th>
                            <td>
                              {jobApplicationDetails?.job_application
                                ?.has_health_issues
                                ? t("Yes")
                                : t("No")}
                            </td>
                          </tr>
                          {jobApplicationDetails?.job_application
                            ?.has_health_issues && (
                            <tr>
                              <th scope="row">{t("Health Issues")}</th>
                              <td>
                                {
                                  jobApplicationDetails?.job_application
                                    ?.health_issues
                                }
                              </td>
                            </tr>
                          )}
                          <tr>
                            <th scope="row">
                              {t(
                                "Have you ever worked in crowd management at the Holy Train of the Sacred Sites?"
                              )}
                            </th>
                            <td>
                              {jobApplicationDetails?.job_application
                                ?.has_crowd_management_exp
                                ? t("Yes")
                                : t("No")}
                            </td>
                          </tr>
                          {jobApplicationDetails?.job_application
                            ?.has_crowd_management_exp && (
                            <tr>
                              <th scope="row">
                                {t("Crowd Management Experience")}
                              </th>
                              <td>
                                {jobApplicationDetails?.job_application?.crowd_management_exp?.map(
                                  item => (
                                    <div
                                      key={item?.job}
                                      className="d-flex align-items-center justify-content-between my-2  pe-3"
                                    >
                                      <h6>{item?.job_title}</h6>
                                      <h6 className="font-bold">
                                        {item?.station_title}
                                      </h6>
                                    </div>
                                  )
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </TabPane>

                {/* Documents Tab */}
                <TabPane tabId="documents">
                  <Card>
                    <CardBody>
                      <Table className="table-wrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Personal Photo")}</th>
                            <td>
                              <Link
                                to={
                                  jobApplicationDetails?.user_information
                                    ?.profile_picture || "#"
                                }
                                className="text-decoration-underline"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("View")}
                              </Link>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("ID/Residence Image")}</th>
                            <td>
                              <Link
                                to={documentsObject["National_ID"] || "#"}
                                className="text-decoration-underline"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("View")}
                              </Link>
                            </td>
                          </tr>
                          {jobApplicationDetails?.user_information?.id_card && (
                            <tr>
                              <th scope="row">{t("ID Card")}</th>
                              <td>
                                <Link
                                  to={
                                    jobApplicationDetails?.user_information
                                      ?.id_card || "#"
                                  }
                                  className="text-decoration-underline"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t("View")}
                                </Link>
                              </td>
                            </tr>
                          )}
                          {/* <tr>
                              <th scope="row">{t("CV")}</th>
                              <td>
                                <Link
                                  to={documentsObject["CV"] || "#"}
                                  className="text-decoration-underline"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t("View")}
                                </Link>
                              </td>
                            </tr> */}
                          {/* {documentsObject["CV"] && ( */}
                          <tr>
                            <th scope="row">{t("CV")}</th>
                            <td>
                              {documentsObject["CV"] ? (
                                <Link
                                  to={documentsObject["CV"] || "#"}
                                  className="text-decoration-underline"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t("View")}
                                </Link>
                              ) : (
                                <p>{t("Not Uploaded")}</p>
                              )}
                            </td>
                          </tr>
                          {/* )} */}
                          {/* {documentsObject["Supporting_Document"] && ( */}
                          <tr>
                            <th scope="row">{t("Supporting Document")}</th>
                            <td>
                              {documentsObject["Supporting_Document"] ? (
                                <Link
                                  to={
                                    documentsObject["Supporting_Document"] ||
                                    "#"
                                  }
                                  className="text-decoration-underline"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View
                                </Link>
                              ) : (
                                <p>{t("Not Uploaded")}</p>
                              )}
                            </td>
                          </tr>
                          {/* )} */}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>
              {jobApplicationDetails?.user_information?.national_id && (
                <Card>
                  <CardBody>
                    <CardTitle>{t("QR Code")}</CardTitle>
                    <div className="mt-4">
                      <QRCodeCanvas
                        value={
                          jobApplicationDetails?.user_information?.national_id
                        }
                        size={300}
                      />
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      )}
    </div>
  )
}

export default CandidateDetails
